import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ActionMenu, IconButton, THEME_CHOICES, themeIcon, useTheme, } from '@kanos/ui';
import { LogOut, UserRound } from 'lucide-react';
import { useSignOut } from './session.js';
/** Up to two initials, e.g. for an account button; the full name is its accessible label. */
export function initials(name, email) {
    const letters = (name ?? email ?? '')
        .split(/[\s.@]+/)
        // Words only: "Muster & Partner" is MP, not M&.
        .filter((part) => /^[\p{L}\p{N}]/u.test(part))
        .slice(0, 2)
        .map((part) => part.charAt(0).toLocaleUpperCase('de-DE'))
        .join('');
    return letters || '?';
}
/**
 * The account behind the round button at the right of the bar (after Corly's user menu):
 * who is signed in and where, the way to the profile, light or dark folded into one entry,
 * and signing out. `context` names where the person is, e.g. the firm; `extra` are the app's
 * own entries after the profile, e.g. switching the firm where the bar has no room for it.
 */
export function AccountMenu({ me, context, onProfile, extra = [], }) {
    const signOut = useSignOut();
    const { preference, setPreference } = useTheme();
    const name = me.displayName ?? me.email ?? 'Ihr Konto';
    return (_jsxs(_Fragment, { children: [_jsx(ActionMenu, { label: `Konto von ${name}`, trigger: _jsx(IconButton, { "aria-label": `Konto von ${name}`, className: "rounded-full", children: initials(me.displayName, me.email) }), header: _jsxs("div", { className: "flex items-center gap-3", children: [_jsx("span", { "aria-hidden": true, className: "grid size-11 shrink-0 place-items-center rounded-full bg-accent-text text-sm font-bold text-ink-contrast", children: initials(me.displayName, me.email) }), _jsxs("div", { className: "grid min-w-0", children: [_jsx("p", { className: "truncate font-semibold", children: name }), me.email && me.email !== name && (_jsx("p", { className: "truncate text-sm text-muted", children: me.email })), context && _jsx("p", { className: "truncate text-sm text-muted", children: context })] })] }), groups: [
                    {
                        id: 'account',
                        items: [{ id: 'profile', label: 'Profil', icon: UserRound, onAction: onProfile }],
                    },
                    ...extra,
                    {
                        id: 'theme',
                        title: 'Darstellung',
                        selected: preference,
                        onSelect: (id) => setPreference(id),
                        items: THEME_CHOICES,
                        folded: { label: 'Darstellung', icon: themeIcon(preference) },
                    },
                    {
                        id: 'end',
                        items: [
                            {
                                id: 'sign-out',
                                label: 'Abmelden',
                                icon: LogOut,
                                isDisabled: signOut.isPending,
                                onAction: () => signOut.mutate(),
                            },
                        ],
                    },
                ] }), signOut.isError && (_jsx("p", { role: "alert", className: "fixed top-20 right-4 z-50 max-w-xs rounded-lg bg-danger-bg px-4 py-3 text-sm text-danger-fg shadow-lg", children: "Abmelden hat nicht geklappt. Bitte versuchen Sie es erneut." }))] }));
}
//# sourceMappingURL=account-menu.js.map